import { t } from "@lingui/macro";
import {
  type CreditAccountForNavigationQuery,
  useCreditAccountForNavigationQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "@src/components/widgets/AppSubNav/hooks";
import type { NavigationHook } from "@src/components/widgets/AppSubNav/hooks/types";

export function useCreditAccountDetailNavigation(
  creditAccountId: string,
): NavigationHook<CreditAccountForNavigationQuery["brandCreditAccount"]> {
  const { data, loading } = useCreditAccountForNavigationQuery({
    fetchPolicy: "cache-first",
    variables: {
      id: creditAccountId,
    },
  });

  const { activePage, activeSubpage, allPages, visiblePages } =
    useNavigationPages([
      {
        title: () => t`Credit accounts`,
        href: {
          pathname: "/invoices/credit-accounts",
        },
      },
    ]);

  return {
    activePage,
    activeSubpage,
    allPages,
    visiblePages,
    isLoading: loading,
    data: data?.brandCreditAccount,
  };
}
